import React from "react";
import "./Header.scss";
import { ADMIN, APP_NAME } from "../../common/contants/constants";
import { MotifLabel } from "@ey-xd/motif-react";
import { getAccount, searchGraphUsers } from "../../common/services/commonService";

import { msalInstance } from "../../common/security/authConfig";
import { useNavigate, useLocation } from "react-router-dom";
import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import { useIsAuthenticated } from "@azure/msal-react";
import AsyncAvatar from "../../common/async-avatar/async-avatar/AsyncAvatar"
import EYP from '../../common/images/EYP.svg'
import logger from "../../common/utils/logger";
import ShareFeedback from "../feedback/ShareFeedback";

export const Header = ({ userRole }) => {
  const [account, setAccount] = React.useState([]);
  const isAuthenticated = useIsAuthenticated();
  const dialogRef = React.useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = React.useState({
    rank: "",
    city: ""
  });

  React.useEffect(() => {
    if (isAuthenticated) {
      const account = getAccount();
      setAccount(account);
      searchGraphUsers(account?.username)
        .then((res) => {
          setUserInfo({ rank: res?.[0]?.rank, city: res?.[0]?.city });
        })

    }
  }, [isAuthenticated])


  const logOutRequest = {
    account,
    postLogoutRedirectUri: "/logout",
  };

  const handleLogout = () => {
    apiQueryWithToken
      .post(`/User/LogoutUser`, {
        emailId: account?.username,
      })
      .then((data) => {
        msalInstance
          .logoutRedirect(logOutRequest)
          .then((data) => {
            sessionStorage.clear();
          })
          .catch((error) => {
            logger.info("Something went wront - ", error);
          });
      })
      .catch((error) => {
        logger.info("Something went wront - ", error);
      });
  };
  const showProfileSection = () => {
    const element = document.getElementById("profile");
    if (element.style.visibility === "visible") {
      element.style.visibility = "hidden";
    } else {
      element.style.visibility = "visible";
    }
  };

  const closeProfileDialog = () => {
    const element = document.getElementById("profile");
    element.style.visibility = "hidden";
  };

  const handleClickOutside = (event) => {
    if (dialogRef.current && !dialogRef.current.contains(event.target)) {
      closeProfileDialog();
    }
  };

  React.useEffect(() => {
    // Set up the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="Header">
      <div className="header-left" onClick={() => { navigate('/') }}>
        <img
          src={EYP}
          alt="logo"
        />
        <div className="header-text">{location.pathname.startsWith('/chat') ? 'DBS AI Chatbot' : APP_NAME}</div>
      </div>
      <div className="header-right">
        {/* <img src={require("../../../src/common/images/bell.png")} alt="bell" /> */}
        {account?.username && (
          <ShareFeedback userEmail={account?.username} userName={account?.name} />
        )}
        <MotifLabel>
          <h4>{account?.username && "Welcome,"}&nbsp; </h4>{" "}
          <span>{getAccount()?.name}</span>
        </MotifLabel>
        {/* <img
          onClick={showProfileSection}
          src={require("../../../src/common/images/user-icon.png")}
          alt="user"
        /> */}
        <span onClick={showProfileSection}><AsyncAvatar id={account?.localAccountId} name={account?.name} size="small" /></span>


        <div id="profile" ref={dialogRef}>
          <div className="view">

            <AsyncAvatar id={account?.localAccountId} name={account?.name} size="medium" />

            <div>
              <div className="name">{getAccount()?.name}</div>
              <div>{userInfo.rank}</div>
            </div>

          </div>


          <div className="list">

            <img src={require("../../../src/common/images/mail.png")} />{" "}  <span >{account?.username}</span></div>

          <div className="list">
            <img src={require("../../../src/common/images/map-pin.png")} />  <span className="view-email">{userInfo.city}</span>
          </div>
          <div className="list">
            {" "}
            <img
              src={require("../../../src/common/images/help-circle.png")}
              alt="help"
              className=""
            />{" "}
            <span onClick={(e) => {
              e.preventDefault();
              navigate(`/help`)

            }} > Get Help</span>
          </div>
          <div className="list" onClick={handleLogout}>
            {" "}
            <img
              src={require("../../../src/common/images/log-out.png")}
              alt="help"
            />{" "}
            <span>Log out</span>
          </div>


          {userRole === ADMIN && (

            <div className="list">
              {" "}
              <img
                src={require("../../../src/common/images/settings.png")}
                alt="help"
              />{" "}
              <span
                onClick={() => {
                  navigate("/settings");
                  closeProfileDialog();
                }}
              >
                Settings
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
